import { createAsyncThunk, createSlice,PayloadAction } from '@reduxjs/toolkit';
import { Status } from '../../../common/constants';
import api from '../../../api';
import { getCookie } from "../../../common/utils";
import {ILicenseState,ILicenseApiResponse } from '../../../common/types/mobileLicensingTypes';
import { getlicensesUrl } from '../../../config';

const initialState: ILicenseState = {
  orgId: null,
  licensingDetails: [],
  status: Status.IDLE,
  error: null
};

export const getOrganisationLicenses = createAsyncThunk<ILicenseApiResponse,string,{rejectValue:string}>('getLicenses', async (orgId: string,{rejectWithValue}) => {
  try {
    const organizationId: string = orgId? orgId : getCookie('organizationId');
    const response = await api.get(getlicensesUrl+`?orgId=${organizationId}`);
    return response.data.message as ILicenseApiResponse;
  } catch (error:any) {
    return rejectWithValue(error.response?.data?.message??error.message??'Something went wrong');
  }
});

const licensingSlice = createSlice({
  name: 'organisationLicenses',
  initialState,
  reducers:{},
  extraReducers: (builder) => {
    builder
      .addCase(getOrganisationLicenses.pending, (state) => {
        state.status = Status.PENDING;
      })
      .addCase(getOrganisationLicenses.fulfilled, (state, action) => {
        state.status = Status.SUCCESS;
        state.orgId = action.payload.orgId;
        state.licensingDetails = action.payload.licensingDetails;
      })
      .addCase(getOrganisationLicenses.rejected, (state, action) => {
        state.status = Status.FAILED;
        state.error = action.payload as string??action.error.message??'Something went wrong';
      });
  },
});

type Selector = {
  organisationLicenses: ReturnType<typeof licensingSlice.reducer>;
};

export const selector = (store: Selector) => store['organisationLicenses'];

export default licensingSlice.reducer;
